var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPinLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19645)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 21.8C11 14.0494 17.0365 9 23.6 9C30.1635 9 36.2 14.0494 36.2 21.8C36.2 24.7031 35.0527 27.4722 33.1241 30.2087C31.1997 32.9394 28.4485 35.7066 25.1261 38.6263C25.1134 38.6375 25.1004 38.6484 25.0872 38.659C24.6656 38.9962 24.1533 39.2 23.6 39.2C23.0467 39.2 22.5344 38.9962 22.1128 38.659C22.0996 38.6484 22.0866 38.6375 22.0739 38.6263C18.7515 35.7066 16.0003 32.9394 14.0759 30.2087C12.1473 27.4722 11 24.7031 11 21.8ZM23.6 11.2C18.1635 11.2 13.2 15.3506 13.2 21.8C13.2 24.0969 14.1027 26.4278 15.8741 28.9413C17.6453 31.4544 20.2356 34.0803 23.5018 36.9523C23.5353 36.9772 23.5601 36.9888 23.5742 36.9941C23.5897 36.9998 23.5975 37 23.6 37C23.6025 37 23.6103 36.9998 23.6258 36.9941C23.6399 36.9888 23.6647 36.9772 23.6982 36.9523C26.9644 34.0803 29.5547 31.4544 31.3259 28.9413C33.0973 26.4278 34 24.0969 34 21.8C34 15.3506 29.0365 11.2 23.6 11.2Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6 24.1C25.0359 24.1 26.2 22.936 26.2 21.5C26.2 20.0641 25.0359 18.9 23.6 18.9C22.1641 18.9 21 20.0641 21 21.5C21 22.936 22.1641 24.1 23.6 24.1Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.2,
    height: 30.2,
    fill: "white",
    transform: "translate(11 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinLight);
export default __webpack_public_path__ + "static/media/icon_pin_light.a28b2e13.svg";
export { ForwardRef as ReactComponent };